import {lazy} from '@aboutyou/lazy-imports';

export const CoinsHistoryTransactionByOrderId = lazy(() =>
  import('./CoinsHistoryTransactionByOrderId.eager').then(mod => ({
    default: mod.CoinsHistoryTransactionByOrderId,
  })),
);
